import { ReactNode } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from "@fortawesome/free-solid-svg-icons"

import styles from './modal.module.css'

export function Modal({ title, onClose, children }: {
    title?: string
    children?: ReactNode
    onClose?: () => void
}) {

    return <div className={styles.modalContainer}>

        { title ?
            <ModalTop>
                { title ?  <ModalTitle>{title}</ModalTitle>: null }
            </ModalTop>
            :
            null }
        { onClose ?
            <FontAwesomeIcon className={styles.closeButton}
                             icon={faXmark}
                             onClick={onClose} />
            :
            null }

        { children }

        
    </div>
}

export function ModalTitle({ children }: {
    children?: ReactNode
}) {
    return <h2 className={styles.modalTitle}>{ children }</h2>
}

export function ModalTop({ children }: {
    children?: ReactNode
}) {
    return <div className={styles.topContent}>{ children }</div>
}

export function ModalContent({ children }: {
    children?: ReactNode
}) {
    return <div className={styles.content} >{ children }</div>
}

export function ModalFooter({ children }: {
    children?: ReactNode
}) {
    return <div className={styles.footer} >{ children }</div>
}
